export default "__VITE_PUBLIC_ASSET__bb497edc__"